import styled from '@emotion/styled';

export const Message = styled.span<{ $type?: 'error' | 'hint' | 'default' }>`
  font-size: 12px;
  color: ${({ theme, $type }) => {
    if ($type === 'hint') return theme.colors.status.warning.normal;
    if ($type === 'error') return theme.colors.status.error.normal;
    return theme.colors.technical.gray[60];
  }};
`;
